import { render, staticRenderFns } from "./MaterialDeliveryModal.vue?vue&type=template&id=db891890&"
import script from "./MaterialDeliveryModal.vue?vue&type=script&lang=js&"
export * from "./MaterialDeliveryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports